module.exports = __webpack_public_path__ + "static/LA-137ca1882d645e01c2d35e63bb1d5f14.png";